<!-- eslint-disable vue/multi-word-component-names -->
<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                style="max-width: 250px"
                :src="logo"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Trocar Senha</h4>
                  <p>Informe a nova senha</p>
                </div>
                <form role="form" @submit.stop.prevent="onSubmit">
                  <div class="flex">
                    <password
                      v-model="form.senha"
                      class="w-full"
                      id="Senha"
                      name="Senha"
                      placeholder="Nova Senha"
                      :secureLength="5"
                      :badge="false"
                      v-validate="{ required: true }"
                      :state="validateState('Senha')"
                      :toggle="true"
                      @score="showScore"
                    />
                  </div>
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-alert
                      v-if="$validator.errors.all().length > 0"
                      color="danger"
                      title="Atenção!!"
                      active="true"
                      class="my-3"
                      style="height: auto !important"
                    >
                      <ul>
                        <li
                          class="mb-2"
                          v-for="error in $validator.errors.all()"
                          :key="error.id"
                        >
                          {{ error }}
                        </li>
                      </ul>
                    </vs-alert>
                  </div>
                  <vs-button class="my-5 float-right">Alterar</vs-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import Password from 'vue-password-strength-meter';
import { decryptData } from './../../services/decryptData';

export default {
  data() {
    return {
      erroLogin: true,
      idEmpresaAux: null,
      empresaSelecionada: false,
      form: {
        senha: null,
        idEmpresa: null,
      },
      checkbox_remember_me: false,
      logo: '',
    };
  },
  methods: {
    showScore(score) {
      this.score = score;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    async onSubmit() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return;
      }

      if (this.score < 2) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Sua Senha Não atingiu os requisitos minimos de Segurança, tente novamente.',
          color: 'danger',
        });
        return;
      }

      this.$vs.loading();
      const token = localStorage.getItem('user-token');
      this.form.token = token;

      try {
        const res = await service.post('Usuario', 'TrocarSenha', this.form);

        if (res.data.token) {
          localStorage.removeItem('user-token');
          location.href = '/Login';
        }
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    selecionaEmpresa() {
      if (localStorage.getItem('idEmpresa'))
        this.form.idEmpresa = localStorage.getItem('idEmpresa');

      if (this.$route.query.idEmpresa)
        this.form.idEmpresa = this.$route.query.idEmpresa;

      if (this.idEmpresaAux) this.form.idEmpresa = this.idEmpresaAux;

      if (this.form.idEmpresa) {
        localStorage.setItem('idEmpresa', this.form.idEmpresa);
        this.buscaDadosEmpresa();
      }
    },
    buscaDadosEmpresa() {
      return new Promise((resolve) => {
        service
          .getAll('g', {}, 'empresas/list/idEmpresa/' + this.form.idEmpresa)
          .then((res) => {
            res.data = decryptData(res.data);
            this.logo = res.data[0].logo;
            localStorage.setItem('logo', this.logo);
            this.empresaSelecionada = true;
            this.erroLogin = false;
            resolve();
          })
          .catch(() => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi encontrado nenhuma Empresa pra Login',
              color: 'danger',
            });
            this.erroLogin = true;
            this.empresaSelecionada = false;
            this.erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
          });
      });
    },
    notify(mensagem, tipo) {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: mensagem,
        color: tipo,
      });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    // localStorage.removeItem('user-token');
    // localStorage.removeItem('p');
    this.selecionaEmpresa();
  },
  components: { Password },
};
</script>
<style>
#inputSenha {
  padding: 0.7rem 2.5rem 0.7rem 3rem;
}
</style>
